export default {
  // Navigation & Layout
  app_name: 'ShareK',
  app_subtitle: 'شارك',
  nav_home: 'Accueil',
  nav_resources: 'Ressources',
  nav_dashboard: 'Tableau de bord',
  nav_my_resources: 'Mes ressources',
  nav_peer_review: 'Peer reviewing',
  nav_messages: 'Messages',
  nav_comments: 'Commentaires',
  nav_profile: 'Mon profil',
  nav_settings: 'Paramètres',
  nav_admin_settings: 'Paramètres admin',
  nav_login: 'Connexion',
  nav_logout: 'Déconnexion',
  nav_add_resource: 'Ajouter une ressource',
  nav_about: 'À propos',
  nav_contact: 'Contactez-nous',

  // Actions communes
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  edit: 'Modifier',
  create: 'Créer',
  submit: 'Soumettre',
  send: 'Envoyer',
  search: 'Rechercher',
  filter: 'Filtrer',
  load_more: 'Charger plus',
  loading: 'Chargement...',
  no_results: 'Aucun résultat',
  back: 'Retour',
  next: 'Suivant',
  close: 'Fermer',
  confirm: 'Confirmer',
  yes: 'Oui',
  no: 'Non',

  // États
  status_draft: 'Brouillon',
  status_under_review: 'En review',
  status_needs_revision: 'À réviser',
  status_peer_reviewed: 'Validé',
  status_published: 'Publié',
  status_not_evaluated: 'Non évalué',
  status_pending_reviewers: 'En attente de reviewers',

  // Types de ressources
  type_course: 'Cours',
  type_worksheet: 'Fiche',
  type_evaluation: 'Évaluation',
  type_practical: 'Activité',
  type_simulation: 'Simulation',
  type_slides: 'Diaporama',

  // Types de commentaires
  comment_pedagogical: 'Pédagogique',
  comment_scientific: 'Scientifique',
  comment_technical: 'Technique',
  comment_general: 'Général',

  // Dashboard
  dashboard_greeting: 'Bonjour, {{name}} !',
  dashboard_subtitle: 'Voici ce qui demande votre attention aujourd\'hui.',
  dashboard_stats_resources: 'Ressources',
  dashboard_stats_validated: 'Validées',
  dashboard_stats_reviews: 'Reviews actives',
  dashboard_stats_comments: 'Commentaires',
  dashboard_section_author: 'Ce sur quoi je travaille',
  dashboard_section_reviewer: 'Mes missions de reviewer',
  dashboard_section_community: 'Messages de la communauté',
  dashboard_empty_author: 'Vous n\'avez pas encore partagé de ressource.',
  dashboard_empty_reviewer: 'Aucune mission de reviewer en cours.',
  dashboard_empty_comments: 'Aucun nouveau commentaire ni mention.',

  // Paramètres
  settings_title: 'Paramètres',
  settings_subtitle: 'Gérez vos informations personnelles, notifications et préférences d\'affichage',
  settings_tab_account: 'Compte',
  settings_tab_notifications: 'Notifications',
  settings_tab_display: 'Affichage',
  settings_tab_security: 'Sécurité',
  settings_account_title: 'Informations du compte',
  settings_account_subtitle: 'Mettez à jour vos informations personnelles',
  settings_name: 'Nom complet',
  settings_name_placeholder: 'Votre nom',
  settings_email: 'Email',
  settings_email_locked: 'L\'email ne peut pas être modifié',
  settings_institution: 'Établissement',
  settings_institution_placeholder: 'Lycée ou collège',
  settings_city: 'Ville',
  settings_city_placeholder: 'Ex: Rabat, Casablanca...',
  settings_specialty: 'Spécialité',
  settings_level: 'Niveau enseigné',
  settings_level_select: 'Sélectionner...',
  settings_level_college: 'Collège',
  settings_level_tcs: 'Tronc commun scientifique',
  settings_level_bac: 'Bac sciences',
  settings_level_all: 'Tous niveaux',
  settings_bio: 'Biographie',
  settings_bio_placeholder: 'Décrivez votre parcours, vos intérêts pédagogiques...',
  settings_bio_count: '{{count}}/500',
  settings_notifications_title: 'Préférences de notification',
  settings_notifications_subtitle: 'Choisissez quand et comment vous être notifié',
  settings_email_notifications: 'Notifications par email',
  settings_email_notifications_desc: 'Recevoir des emails pour les événements importants',
  settings_push_notifications: 'Notifications push',
  settings_push_notifications_desc: 'Alertes en temps réel dans l\'application',
  settings_event_new_comment: 'Nouveau commentaire',
  settings_event_new_comment_desc: 'Quand quelqu\'un commente votre ressource',
  settings_event_new_review: 'Nouveau reviewer',
  settings_event_new_review_desc: 'Quand un enseignant accepte de reviewer votre ressource',
  settings_event_recommendation: 'Recommandation soumise',
  settings_event_recommendation_desc: 'Quand un reviewer dépose son fichier de recommandation',
  settings_display_title: 'Préférences d\'affichage',
  settings_display_subtitle: 'Personnalisez l\'apparence de l\'application',
  settings_language: 'Langue',
  settings_language_fr: 'Français',
  settings_language_ar: 'العربية',
  settings_theme: 'Thème',
  settings_theme_light: 'Clair',
  settings_theme_dark: 'Sombre',
  settings_theme_system: 'Système',
  settings_security_title: 'Sécurité du compte',
  settings_security_subtitle: 'Gérez votre mot de passe et la connexion',
  settings_change_password: 'Changer le mot de passe',
  settings_change_password_desc: 'Vous recevrez un email avec un lien de réinitialisation',
  settings_reset_password_btn: 'Réinitialiser',
  settings_reset_email_sent: 'Email de réinitialisation envoyé !',
  settings_logout: 'Déconnexion',
  settings_logout_desc: 'Vous devrez vous reconnecter pour accéder à votre compte',
  settings_logout_btn: 'Se déconnecter',
  settings_danger_zone: 'Zone de danger',
  settings_danger_subtitle: 'Ces actions sont irréversibles',
  settings_delete_account: 'Supprimer mon compte',
  settings_delete_account_desc: 'Toutes vos ressources, commentaires et données seront supprimés définitivement',
  settings_delete_account_confirm: 'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
  settings_delete_account_btn: 'Supprimer',
  settings_saved: 'Modifications enregistrées',
  settings_saving: 'Enregistrement...',
  settings_current_password: 'Mot de passe actuel',
  settings_new_password: 'Nouveau mot de passe',
  settings_confirm_password: 'Confirmer le mot de passe',
  settings_password_updated: 'Mot de passe mis à jour avec succès',
  settings_password_error: 'Erreur lors de la mise à jour du mot de passe',
  settings_password_mismatch: 'Les mots de passe ne correspondent pas',
  settings_password_too_short: 'Le mot de passe doit contenir au moins 6 caractères',
  settings_update_password_btn: 'Mettre à jour le mot de passe',

  // Messages / Chat
  msg_online: 'En ligne',
  msg_offline: 'Hors ligne',
  msg_seen: 'Vu',
  msg_typing: 'écrit...',
  msg_no_conversations: 'Aucune conversation',
  msg_start_chat: 'Commencez à discuter avec un auteur depuis son profil ou une ressource.',
  msg_placeholder: 'Écrivez un message...',
  msg_send_hint: 'Entrée pour envoyer · Shift+Entrée pour sauter une ligne · Max 3 fichiers (5 Mo chacun)',
  msg_attach_image: 'Image',
  msg_attach_pdf: 'PDF',
  msg_attachment_max: 'Max 3 fichiers atteint',

  // Peer Review
  pr_join: 'Participer comme reviewer',
  pr_status_reading: 'Lecture',
  pr_status_accepted: 'Accepté',
  pr_status_recommendation: 'Recommandation',
  pr_anonymous: 'Anonymisé',
  pr_reviewer: 'Reviewer',

  // Home / Landing
  home_hero_title: 'Partagez vos connaissances,',
  home_hero_subtitle: 'enrichissez l\'enseignement',
  home_hero_desc: 'ShareK est un espace collaboratif où les enseignants de Sciences de la Vie et de la Terre partagent, évaluent et améliorent ensemble les ressources pédagogiques.',
  home_search_placeholder: 'Rechercher une ressource par titre, thème ou mot-clé...',
  home_stats_resources: 'Ressources partagées',
  home_stats_teachers: 'Enseignants actifs',
  home_stats_validated: 'Ressources validées',
  home_stats_reviews: 'Peer reviews réalisés',
  home_about_share: 'Partager',
  home_about_share_desc: 'Mettez à disposition de la communauté vos cours, fiches, évaluations et activités pédagogiques.',
  home_about_evaluate: 'Évaluer',
  home_about_evaluate_desc: 'Recevez des retours constructifs de vos pairs grâce au peer reviewing pour enrichir vos ressources.',
  home_about_validate: 'Valider',
  home_about_validate_desc: 'Accédez à des contenus de qualité validés par la communauté et prêts à être utilisés en classe.',
  home_resources_title: 'Ressources partagées',
  home_resources_subtitle: 'Découvrez les cours, fiches, évaluations et activités de la communauté',
  home_teachers_title: 'Enseignants actifs',
  home_teachers_subtitle: 'Les contributeurs qui enrichissent la plateforme',
  home_contact_title: 'Contactez-nous',
  home_contact_desc: 'Une question, une suggestion ou envie de rejoindre l\'aventure ?',
  home_contact_email: 'contact@sharek.ma',
  home_contact_location: 'Maroc',

  // Login / Signup
  login_title: 'Connexion',
  login_email: 'Email',
  login_password: 'Mot de passe',
  login_btn: 'Se connecter',
  login_forgot_password: 'Mot de passe oublié ?',
  login_no_account: 'Pas encore de compte ?',
  login_signup_link: 'S\'inscrire',
  signup_title: 'Inscription',
  signup_name: 'Nom complet',
  signup_email: 'Email',
  signup_password: 'Mot de passe',
  signup_btn: 'S\'inscrire',
  signup_has_account: 'Déjà un compte ?',
  signup_login_link: 'Se connecter',
  auth_error_invalid: 'Email ou mot de passe incorrect',
  auth_error_generic: 'Une erreur est survenue. Veuillez réessayer.',

  // Admin Settings
  admin_settings_title: 'Paramètres de la plateforme',
  admin_settings_subtitle: 'Gérez les catégories de ressources et les paramètres globaux de ShareK',
  admin_settings_tab_categories: 'Catégories',
  admin_settings_tab_platform: 'Paramètres globaux',
  admin_settings_categories_desc: 'Organisez les niveaux scolaires, types de ressources, unités pédagogiques et spécialités disponibles sur la plateforme.',
  admin_settings_platform_desc: 'Configurez le nom de la plateforme, les limites d\'upload, les fonctionnalités activées et les textes publics.',
  admin_settings_cat_type_level: 'Niveaux scolaires',
  admin_settings_cat_type_type: 'Types de ressources',
  admin_settings_cat_type_unit: 'Unités pédagogiques',
  admin_settings_cat_type_specialty: 'Spécialités',
  admin_settings_cat_name: 'Nom',
  admin_settings_cat_slug: 'Identifiant',
  admin_settings_cat_active: 'Actif',
  admin_settings_cat_order: 'Ordre',
  admin_settings_cat_add: 'Ajouter une catégorie',
  admin_settings_cat_edit: 'Modifier',
  admin_settings_cat_delete: 'Supprimer',
  admin_settings_cat_delete_confirm: 'Supprimer cette catégorie ? Elle ne sera plus proposée dans les formulaires mais les ressources existantes ne seront pas affectées.',
  admin_settings_cat_save: 'Enregistrer la catégorie',
  admin_settings_cat_cancel: 'Annuler',
  admin_settings_platform_name: 'Nom de la plateforme',
  admin_settings_platform_tagline: 'Slogan',
  admin_settings_platform_hero_title: 'Titre bannière accueil',
  admin_settings_platform_hero_subtitle: 'Sous-titre bannière accueil',
  admin_settings_platform_contact_email: 'Email de contact',
  admin_settings_platform_max_upload: 'Taille max upload (Mo)',
  admin_settings_platform_max_reviewers: 'Reviewers max par ressource',
  admin_settings_platform_min_reviewers: 'Reviewers min requis',
  admin_settings_platform_resources_per_page: 'Ressources par page',
  admin_settings_platform_comments_per_page: 'Commentaires par page',
  admin_settings_platform_analytics_retention: 'Rétention analytics (jours)',
  admin_settings_platform_default_language: 'Langue par défaut',
  admin_settings_platform_enable_signups: 'Autoriser les inscriptions',
  admin_settings_platform_enable_peer_review: 'Activer le peer review',
  admin_settings_platform_enable_comments: 'Activer les commentaires',
  admin_settings_platform_enable_messages: 'Activer la messagerie',
  admin_settings_platform_auto_assign_reviewers: 'Assignation auto des reviewers',
  admin_settings_platform_maintenance_mode: 'Mode maintenance',
  admin_settings_saved: 'Paramètres enregistrés',
  admin_settings_save: 'Enregistrer les paramètres',
  admin_settings_saving: 'Enregistrement...',
  admin_settings_reset: 'Réinitialiser les valeurs par défaut',
  admin_settings_no_categories: 'Aucune catégorie dans cette section',
  admin_settings_add_first_category: 'Ajoutez la première catégorie',

  // Errors / Misc
  error_generic: 'Une erreur est survenue',
  error_not_found: 'Page introuvable',
  error_not_found_desc: 'La page que vous recherchez n\'existe pas ou a été déplacée.',
  error_back_home: 'Retour à l\'accueil',
};